module.exports = __webpack_public_path__ + "static/media/halfroundSlim.2bb779af.jpg";